import { useMemo } from 'react';

import { useNotificationDefinitionsQuery } from 'hooks/queries/notifications';

import { CatalogueItem, definitionToCatalogueItem } from './constants';

/**
 * Notification catalog for read-only browsing (WIRE-2608): the endpoint
 * returns the full, bounded catalog; view items are sorted by name.
 */
export const useNotificationCatalogue = () => {
  const { definitions, isLoading, error, refetch } =
    useNotificationDefinitionsQuery();

  const items = useMemo<CatalogueItem[]>(
    () =>
      (definitions ?? [])
        .map(definitionToCatalogueItem)
        .sort((a: CatalogueItem, b: CatalogueItem) =>
          a.name.localeCompare(b.name)
        ),
    [definitions]
  );

  return { items, isLoading, error, refetch };
};
